import React from 'react';
import { TypographyComponent as TypographyElement } from '@tvg/fuse-design';
import { NonReturnableInfoProps } from './NonReturnableInfoProps';

function NonReturnableInfo({ returnable }: NonReturnableInfoProps): JSX.Element {
  const { beforeLink, afterLink, link } = returnable;

  return (
    <TypographyElement size="m1" tag="p" type="paragraph" data-testid="non-returnable-wrapper">
      {`${beforeLink} `}
      <a href={link.href}>{link.text}</a>
      {` ${afterLink}`}
    </TypographyElement>
  );
}

export default NonReturnableInfo;
